import React from 'react';
import moment from 'moment';
import { useRef, useState, useContext, useEffect, useMemo } from 'react';
import {
  useResponsiveParams,
  QuantaFormik,
  QuantaForm,
  useQuantaFormikContext,
  MixedGridGroup,
  Text,
  SearchResultsModal,
  Paper,
  Button,
  Label,
} from 'quanta-ui';
import { useQuery } from '@apollo/client';
import {
  //GET_BUY_FIRE_POLICY_VAR_DETAILS,
  FINANCER_DROPDOWN_DETAILS,
  FINANCER_DROPDOWN_DETAILS_FIRE
} from '../queries';
import { COVER_FIRESA } from '../../../../capture-details/fire/Standalone Fire/queries';
import { GET_BUY_FIRE_POLICY_VAR_DETAILS } from 'quanta-flows/modules/proposal/fire';
// import Loading from '../../../../../lib/layout/loading';
import { Loading } from 'quanta-flows/modules/layout';
//import { updateBuyFirePolicyVar } from '../_graphql/state';
import { updateBuyFirePolicyVar } from 'quanta-flows/modules/proposal/fire/state';
import { FloaterLocationModal } from 'quanta-flows/modules/quote/fire';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { QuantaConfigContext } from 'quanta-flows';
import { faSearch, faInfoCircle, faTrashAlt, faPlus } from '@fortawesome/free-solid-svg-icons';
import { useFetchQuery } from 'quanta-flows';
export default function InsuredMembersDetailsFire({
  goToStep,
  proceedToNextStep,
  setProceedToNextStep,
  setParentAlerts,
  lobCode,
  lobName,
  productName,
  productCode,
  proposalNumber,
  renderExpandedCards,
  ...props
}) {
  let repeat = useResponsiveParams({ for_mobile: 1, for_desktop: 3 });
  const {
    loading: loadingBuyPolicy,
    error: errorBuyPolicy,
    data: dataBuyPolicy,
  } = useQuery(GET_BUY_FIRE_POLICY_VAR_DETAILS);
  const fetchQuery = useFetchQuery();
  const { branding } = useContext(QuantaConfigContext);
  const changeInputType = useResponsiveParams({
    for_mobile: 'input-lookup',
    for_desktop: 'text',
  });
  const colSpanParams = useResponsiveParams({
    for_mobile: { searchString: 8, button: 2 },
    for_desktop: { searchString: 4, button: 1 },
  });
  const screenType = useResponsiveParams({
    for_mobile: 'mobile',
    for_desktop: 'desktop',
  });
  const modalSizeExternal = useResponsiveParams({
    for_desktop: 'large',
    for_mobile: 'small',
    for_iPad: 'large',
  });
  const icon_idle = (
    <img
      src={branding.illustration.no_data}
      alt="no data"
      className="lg:w-80 lg:h-80 w-64 h-64 opacity-50"
    />
  );

  const {
    loading: loadingFinancerTypeData,
    error: errorFinancerTypeData,
    data: FinancerTypeData,
  } = useQuery(FINANCER_DROPDOWN_DETAILS, {
    fetchPolicy: 'cache-first',
    variables: {
      input: {
        domainType: 'Financier Agreement Type',
        productCode: '1131',
      },
    },
  });

  const {
    loading: loadingFinancerNameData,
    error: errorFinancerNameData,
    data: FinancerNameData,
  } = useQuery(FINANCER_DROPDOWN_DETAILS, {
    fetchPolicy: 'cache-first',
    variables: {
      input: { domainType: 'Financier Name' },
    },
  });

  if (
    loadingBuyPolicy ||
    loadingFinancerTypeData ||
    loadingFinancerNameData
  ) {
    return (
      <div className="min-h-screen">
        <Loading customMessage={'Fetching members'} />
      </div>
    );
  }
  if (
    errorBuyPolicy ||
    errorFinancerTypeData ||
    errorFinancerNameData
  ) {
    return (
      <div className="min-h-screen">
        <Error error={errorBuyPolicy} />
      </div>
    );
  }
  //const [hometype, sethometype] = useState('0');
  const { buyFirePolicy } = dataBuyPolicy;
  const { quoteData } = buyFirePolicy;
  const { tabDetails } = quoteData;
  const { customerTabDetails } = tabDetails;
  const {
    customerDetails,
    policyTypeDetails,
    previousClaimExperienceDetails,
  } = customerTabDetails;
  const { getDomainData } = FinancerTypeData;
  var floortype = '';
  const floornumber = (val) => {
    if (val === '') {
      floortype = 'Multi-Storey'
    }
  }
  const initialMemberList = [
    {
      relationship: 'Self',
      gender: null,
      selectGender: true,
      sumInsured: "",
      maxAllowed: 1,
      selected: false,
      nomineeAge: "",
      nomineeName: "",
      nomineeRelationship: "",
      dob: "",
      age: "",
      name: ""
    },
    // {
    //   label: 'Spouse',
    //   gender: null,
    //   selectGender: true,
    //   maxAllowed: 1,
    //   selected: false,
    // },
  ];
  const applicableMemberTypes = [
    { label: 'Self', gender: 'Female', selectGender: false, maxAllowed: 3 },
    { label: 'Child 1', gender: 'Female', selectGender: false, maxAllowed: 3 },
    { label: 'Child 2	', gender: 'Male', selectGender: false, maxAllowed: 1 },
    { label: 'Mother', gender: 'Male', selectGender: false, maxAllowed: 1 },
    { label: 'Mother in law', gender: 'Female', selectGender: false, maxAllowed: 1 },
    { label: 'Father', gender: 'Female', selectGender: false, maxAllowed: 1 },
    { label: 'Father in law', gender: 'Male', selectGender: false, maxAllowed: 3 },
    { label: 'Spouse', gender: 'Any', selectGender: true, maxAllowed: 1 }
  ];
  const applicableNomineeTypes = [
    { label: 'Child 1', gender: 'Female', selectGender: false, maxAllowed: 3 },
    { label: 'Child 2	', gender: 'Male', selectGender: false, maxAllowed: 1 },
    { label: 'Mother', gender: 'Male', selectGender: false, maxAllowed: 1 },
    { label: 'Mother in law', gender: 'Female', selectGender: false, maxAllowed: 1 },
    { label: 'Father', gender: 'Female', selectGender: false, maxAllowed: 1 },
    { label: 'Father in law', gender: 'Male', selectGender: false, maxAllowed: 3 },
    { label: 'Spouse', gender: 'Any', selectGender: true, maxAllowed: 1 }
  ];
  const genderList = [
    { code: 'MALE', value: 'Male' }
    ,
    { code: 'FEMALE', value: 'Female' }
    ,
    { code: 'OTHER', value: 'Other' }
  ]
  const getInitObject = () => {
    let initObj = {};

    initObj = {
      businessOfInsured: customerDetails?.businessOfInsured,
      policyTypeDetails: {
        policyStartDate: policyTypeDetails?.policyStartDate,
        isInsuranceForKutchaConstruction:
          policyTypeDetails?.isInsuranceForKutchaConstruction,
        tenure: {
          code: policyTypeDetails?.tenure?.code,
          value: policyTypeDetails?.tenure?.value,
        },
        policyOrCoverType: {
          code: policyTypeDetails?.policyOrCoverType?.code,
          value: policyTypeDetails?.policyOrCoverType?.value,
        },
      },
      riskDetails: {
        policyStartDate: buyFirePolicy?.riskDetails?.policyStartDate
          ? buyFirePolicy?.riskDetails?.policyStartDate
          : policyTypeDetails?.policyStartDate,
        hometype: buyFirePolicy?.riskDetails?.hometype
          ? buyFirePolicy?.riskDetails?.hometype
          : '',
        floornumber: buyFirePolicy?.riskDetails?.floornumber
          ? buyFirePolicy?.riskDetails?.floornumber
          : '',
        basement: buyFirePolicy?.riskDetails?.basement
          ? buyFirePolicy?.riskDetails?.basement
          : '',
        basementsi: buyFirePolicy?.riskDetails?.basementsi
          ? buyFirePolicy?.riskDetails?.basementsi
          : '',
        buildingage: buyFirePolicy?.riskDetails?.buildingage
          ? buyFirePolicy?.riskDetails?.buildingage
          : '',
        walls: buyFirePolicy?.riskDetails?.walls
          ? buyFirePolicy?.riskDetails?.walls
          : '',
        floor: buyFirePolicy?.riskDetails?.floor
          ? buyFirePolicy?.riskDetails?.floor
          : '',
        roof: buyFirePolicy?.riskDetails?.roof
          ? buyFirePolicy?.riskDetails?.roof
          : '',
        updaterisk: buyFirePolicy?.riskDetails?.updaterisk
          ? buyFirePolicy?.riskDetails?.updaterisk
          : 'No',
        updateriskaddress: buyFirePolicy?.riskDetails?.updateriskaddress
          ? buyFirePolicy?.riskDetails?.updateriskaddress
          : buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.addressDetails?.addressLine1,
        height_of_the_Building: buyFirePolicy?.riskDetails?.height_of_the_Building
          ? buyFirePolicy?.riskDetails?.height_of_the_Building
          : '',
        typeOfConstruction: buyFirePolicy?.riskDetails?.typeOfConstruction
          ? buyFirePolicy?.riskDetails?.typeOfConstruction
          : '',
        deductible: quoteData?.productKg?.toString() === 'Kotak Griha Raksha Plus'
          ? "Nil"
          : '',
        construction_Details: buyFirePolicy?.riskDetails?.construction_Details
          ? buyFirePolicy?.riskDetails?.construction_Details
          : 'Concrete Frame Construction',
        Fire_Protection_Type: buyFirePolicy?.riskDetails?.Fire_Protection_Type
          ? buyFirePolicy?.riskDetails?.Fire_Protection_Type
          : '',
        PreAcceptance_Inspection: buyFirePolicy?.riskDetails?.PreAcceptance_Inspection
          ? buyFirePolicy?.riskDetails?.PreAcceptance_Inspection
          : 'No',
        PreAcceptance_Inspection_Date: buyFirePolicy?.riskDetails?.PreAcceptance_Inspection_Date
          ? buyFirePolicy?.riskDetails?.PreAcceptance_Inspection_Date
          : '',
        Voluntary_Deductible: buyFirePolicy?.riskDetails?.Voluntary_Deductible
          ? buyFirePolicy?.riskDetails?.Voluntary_Deductible
          : 'No',
        Voluntary_Deductible_PCT: buyFirePolicy?.riskDetails?.Voluntary_Deductible_PCT
          ? buyFirePolicy?.riskDetails?.Voluntary_Deductible_PCT
          : '',
        Voluntary_Deductible_Amount: buyFirePolicy?.riskDetails?.Voluntary_Deductible_Amount
          ? buyFirePolicy?.riskDetails?.Voluntary_Deductible_Amount
          : '',
      },
      nomineeDetails: {
        nomineeName: buyFirePolicy?.additionalTabDetails
          ?.nomineeDetails?.nomineeName
          ? `${buyFirePolicy?.additionalTabDetails?.nomineeDetails?.nomineeName}`
          : '',
        nomineeDob: buyFirePolicy?.additionalTabDetails?.nomineeDetails
          ?.nomineeDob
          ? `${buyFirePolicy?.additionalTabDetails?.nomineeDetails?.nomineeDob}`
          : '',
        relationshipWithNominee: buyFirePolicy?.additionalTabDetails
          ?.nomineeDetails?.relationshipWithNominee
          ? `${buyFirePolicy?.additionalTabDetails?.nomineeDetails?.relationshipWithNominee}`
          : '',
        nameOfAppointee: buyFirePolicy?.additionalTabDetails
          ?.nomineeDetails?.nameOfAppointee
          ? `${buyFirePolicy?.additionalTabDetails?.nomineeDetails?.nameOfAppointee}`
          : '',
        relationshipWithAppointee: buyFirePolicy?.additionalTabDetails
          ?.nomineeDetails?.relationshipWithAppointee
          ? `${buyFirePolicy?.additionalTabDetails?.nomineeDetails?.relationshipWithAppointee}`
          : '',
      },
      members: buyFirePolicy?.members
        ? buyFirePolicy?.members
        : [
          {
            relationship: 'Self',
            gender: null,
            selectGender: true,
            sumInsured: "",
            maxAllowed: 1,
            selected: false,
            nomineeAge: "",
            nomineeName: "",
            nomineeRelationship: "",
            dob: "",
            age: "",
            name: ""
          }
        ],
      previousClaimExperienceDetails: {
        isClaimMadeInPreviousYears:
          previousClaimExperienceDetails?.isClaimMadeInPreviousYears,
        claimInPreviousYearsInfo:
          previousClaimExperienceDetails?.claimInPreviousYearsInfo,
      },
      getFinancerDetails: buyFirePolicy?.financierDetails
        ?.getFinancerDetails
        ? `${buyFirePolicy?.financierDetails?.getFinancerDetails}`
        : '',

      financerName: buyFirePolicy?.financierDetails?.financerName
        ? `${buyFirePolicy?.financierDetails?.financerName}`
        : '',
      financerAddress: buyFirePolicy?.financierDetails
        ?.financerAddress
        ? `${buyFirePolicy?.financierDetails?.financerAddress}`
        : '',
      financerAgreementType: buyFirePolicy?.financierDetails
        ?.financerAgreementType?.length > 0
        ? `${buyFirePolicy?.financierDetails?.financerAgreementType}`
        : 'Hypothecation',
      loanAccountNumber: buyFirePolicy?.financierDetails
        ?.loanAccountNumber
        ? `${buyFirePolicy?.financierDetails?.loanAccountNumber}`
        : '',
      fileNumber: buyFirePolicy?.financierDetails?.fileNumber
        ? `${buyFirePolicy?.financierDetails?.fileNumber}`
        : '',
    };

    return initObj;
  };
  const initialValues = getInitObject();

  const validate = (values) => {
    let errors = {};
    errors.riskDetails = {};
    errors.members = [];
    let errorCount = 0;
    let nominee = false
    quoteData.riskcoverdata[0].covers.forEach
      ((cov) => {
        if (cov?.name?.toString() === 'Personal Accident Cover'
          || cov?.name?.toString() === 'Personal Accident Cover Self'
          || cov?.name?.toString() === 'Personal Accident Cover Spouse') {
          nominee = true
        }
      })
    //// console.log('insured details values',values)
    if (!values?.riskDetails.policyStartDate) {
      errorCount += 1;
      errors.riskDetails.policyStartDate = '* Required';
    }
    if (values?.riskDetails.policyStartDate !== null) {
      if (
        moment(new Date(), 'DD/MM/YYYY').diff(
          moment(values?.riskDetails.policyStartDate, 'DD/MM/YYYY'), 'days') !== 0) {
        if (moment(values?.riskDetails.policyStartDate, 'DD/MM/YYYY').isBefore()) {
          errorCount += 1;
          errors.riskDetails.policyStartDate = '* Backdated date kindly provide appropriate date in policy start date';
        }
      }
    }
    if ((values?.riskDetails?.hometype.toString() === 'Multi-Storey' && values?.riskDetails?.hometype.toString() !== 'Standalone House')
      && values?.policyTypeDetails?.policyOrCoverType?.value === ('Home Building And Home Contents' || 'Home Buildings Only')) {
      if (!values?.riskDetails?.floornumber) {
        errors.riskDetails.floornumber = '* Required';
        errorCount += 1;
      }
      if (values?.riskDetails?.floornumber.length > 3) {
        errorCount += 1;
        errors.riskDetails.floornumber = 'floor range cannot exceed 3 digits';
      }
    }
    if (values?.riskDetails.basementsi !== null) {
      if (values?.riskDetails?.basementsi.length > 30) {
        errorCount += 1;
        errors.riskDetails.basementsi = 'floor range cannot exceed 3 digits';
      }
    }
    if (values?.getFinancerDetails === 'Yes') {
      if (!values.financerName) {
        errors.financerName = '* Required';
        errorCount += 1
      } else if (!values.loanAccountNumber) {
        errors.loanAccountNumber = '* Required';
        errorCount += 1
      } else if (!values.financerAgreementType) {
        errors.financerAgreementType = '* Required';
        errorCount += 1
      } else if (!values.financerAddress) {
        errors.financerAddress = '* Required';
        errorCount += 1
      }
    }
    if (quoteData?.productKg !== 'Home Contents Only') {
      if (!values?.riskDetails?.height_of_the_Building) {
        errorCount += 1;
        errors.riskDetails.height_of_the_Building = '* Required';
      }
      if (!values?.riskDetails?.buildingage) {
        errorCount += 1;
        errors.riskDetails.buildingage = '* Required';
      }
      if (!values?.riskDetails?.typeOfConstruction) {
        errorCount += 1;
        errors.riskDetails.typeOfConstruction = '* Required';
      }
      if (!values?.riskDetails?.Fire_Protection_Type) {
        errorCount += 1;
        errors.riskDetails.Fire_Protection_Type = '* Required';
      }
      // if (!values?.riskDetails?.floornumber) {
      //   errors.riskDetails.floornumber = '* Required';
      //   errorCount += 1;
      // }
    }
    if (values?.riskDetails?.typeOfConstruction?.toString() === 'Pucca') {
      if (!values?.riskDetails?.construction_Details) {
        errorCount += 1;
        errors.riskDetails.construction_Details = '* Required';
      }
    }
    if (values?.riskDetails?.PreAcceptance_Inspection?.toString() === 'Yes') {
      if (!values?.riskDetails?.PreAcceptance_Inspection_Date) {
        errors.riskDetails.PreAcceptance_Inspection_Date = '* Required';
        errorCount += 1
      }
      if (values?.riskDetails?.PreAcceptance_Inspection_Date) {
        if (
          moment(values?.riskDetails?.PreAcceptance_Inspection_Date, 'DD/MM/YYYY').diff(
            moment(values?.riskDetails.policyStartDate, 'DD/MM/YYYY'), 'days') >= 0) {
          errors.riskDetails.PreAcceptance_Inspection_Date = '* Pre Inspection date should be less than Policy start Date';
          errorCount += 1
        }
      }
    }
    if (values?.riskDetails?.Voluntary_Deductible?.toString() === 'Yes') {
      if (!values?.riskDetails?.Voluntary_Deductible_PCT) {
        errors.riskDetails.Voluntary_Deductible_PCT = '* Required';
        errorCount += 1
      }
      if (values?.riskDetails?.Voluntary_Deductible_PCT) {
        if (values?.riskDetails?.Voluntary_Deductible_PCT?.length > 3) {
          errors.riskDetails.Voluntary_Deductible_PCT = '* Voluntary Deductible % data length should not be greater than 3';
          errorCount += 1
        }
        if (values?.riskDetails?.Voluntary_Deductible_PCT > 100) {
          errors.riskDetails.Voluntary_Deductible_PCT = '* Voluntary Deductible % should not be greater than 100%';
          errorCount += 1
        }
      }
      if (!values?.riskDetails?.Voluntary_Deductible_Amount) {
        errors.riskDetails.Voluntary_Deductible_Amount = '* Required';
        errorCount += 1
      }
      if (values?.riskDetails?.Voluntary_Deductible_Amount?.length > 14) {
        errors.riskDetails.Voluntary_Deductible_Amount = '* Length should not exceed 14';
        errorCount += 1
      }
    }
    errors.members = values?.members?.map((_) => {
      return {};
    });
    if (nominee) {
      if (values?.members?.length) {
        values?.members?.forEach((mem, idx) => {
          if (!mem?.relationship) {
            errors.members[idx] = {
              ...errors.members[idx],
              relationship: '* Required',
            };
          }
          if (!mem?.name) {
            errors.members[idx].name = '* Required'
          }
          if (mem?.name?.length > 200) {
            errors.members[idx].name = '* name length cannot exceed 200 characters'
          }
          if (mem?.nomineeName?.length > 200) {
            errors.members[idx].nomineeName = '* name length cannot exceed 200 characters'
          }
          if (mem?.age?.length > 2) {
            errors.members[idx].age = '* name length cannot exceed 2 characters'
          }
          // if(mem?.nomineeRelationship)
          // {
          //   if(mem?.nomineeRelationship?.toString() === mem?.relationship?.toString() )
          //   {
          //     errors.members.nomineeRelationship = '* Relationship cannot be same as nominee Relation '
          //   }
          // }
        })
      }
    }
    if (errorCount > 0) {
      return errors;
    }
    return {};
  };

  const InsuredMemberForm = ({ validate }) => {
    const { values, setFieldValue } = useQuantaFormikContext();
    const [financierNameModalDisplay, showFinancierNameModal] =
      useState(false);
    const [financierNameOutput, setFinancierNameOutput] = useState(
      [],
    );
    const [nomineeDisplay, setNomineeDisplay] =
      useState(false);
    const [errors, setErrors] = useState({ financierNameList: '' });
    const [onDataUpdate, setOnUpdate] = useState(null);
    const [loadingFinancierName, setLoadingFinancierName] =
      useState(false);
    const [searchStringFinancierName, setSearchStringFinancierName] =
      useState('');
    let [showModalAddOthers, setShowModalAddOthers] = useState(false);
    const [memberList, setMemberList] = useState(buyFirePolicy?.members ? buyFirePolicy?.members : initialMemberList);
    useEffect(() => {
      quoteData.riskcoverdata[0].covers?.forEach((cov) => {
        if (cov?.name?.toString() === 'Personal Accident Cover'
          || cov?.name?.toString() === 'Personal Accident Cover Self'
          || cov?.name?.toString() === 'Personal Accident Cover Spouse') {
          setNomineeDisplay(true)
        }
      }
      )
    }, []
    )
    const reformData = (val, returnType) => {
      return val && val.toString().trim() !== '' ? val : returnType;
    };
    const onFinancierNameSearch = async (val, _) => {
      if (val.length > 0) {
        try {
          setFinancierNameOutput([]);
          let queryOutput = fetchQuery({
            fetchPolicy: 'network-only',
            query: FINANCER_DROPDOWN_DETAILS_FIRE
            ,
            // variables: {
            //   value: val,
            // },
            variables: {
              input: {
                bankName: val,
              },
            }
          });
          setLoadingFinancierName(true);
          let { data } = await queryOutput;
          setLoadingFinancierName(false);
          // setFinancierNameOutput(data.carsecureFinancierSearch.financier);
          setFinancierNameOutput(data.FireFinancierSearch.financier);
        } catch (error) {
          setErrors({
            ...errors,
            financierNameList: error?.message,
          });
          setLoadingFinancierName(false);
          setFinancierNameOutput([]);
        }
      }
    };
    const searchInput = {
      flow: 'cols',
      repeat: 5,
      data:
        changeInputType === 'text'
          ? [
            {
              type: 'text',
              name: 'searchString',
              size: 'full',
              colSpan: colSpanParams.searchString,
            },
            {
              type: 'submit',
              size: 'full',
              colSpan: colSpanParams.button,
              iconPre: <FontAwesomeIcon icon={faSearch} />,
              children: 'Search',
            },
          ]
          : [
            {
              type: 'input-lookup',
              name: 'searchString',
              size: 'full',
              colSpan: colSpanParams.searchString,
              onLookup: onFinancierNameSearch,
            },
          ],
      initialValues: {
        searchString: searchStringFinancierName,
      },
      validate: (values) => {
        const errors = {};
        if (!values.searchString) errors.searchString = '* Required';
        return errors;
      },
      onSearch: async (values) => {
        try {
          setFinancierNameOutput([]);
          let queryOutput = fetchQuery({
            fetchPolicy: 'network-only',
            query: FINANCER_DROPDOWN_DETAILS_FIRE,
            variables: {
              input: {
                bankName: values.searchString
                //  , value: values.searchString,
              },
            }
            // variables: {
            //   value: values.searchString,
            //   bankName: val,
            // },
          });
          setLoadingFinancierName(true);
          let { data } = await queryOutput;
          setLoadingFinancierName(false);
          // data.bankName
          // setFinancierNameOutput(data.carsecureFinancierSearch.financier);
          setFinancierNameOutput(data.FireFinancierSearch.financier);
        } catch (error) {
          setErrors({
            ...errors,
            financierNameList: error?.message,
          });
          setLoadingFinancierName(false);
          setFinancierNameOutput([]);
        }
      },
    };
    const searchResults = {
      data: financierNameOutput,
      onIdle: () => {
        if (loadingFinancierName) {
          return <Loading />;
        } else if (searchStringFinancierName === '') {
          return icon_idle;
        }
        return undefined;
      },
      columns: [
        {
          Header: 'Financer Name',
          accessor: 'bankName',
        },
      ],
      list: financierNameOutput.map((data) => {

        return {
          // title: `${data.value}`,
          title: `${data.bankName}`,
          onClick: () => {
            onDataUpdate(data);
            showFinancierNameModal(false);
            // financierNameModalDisplayRef.current = false
            // showFinancierNameModal(financierNameModalDisplayRef.current) //false);
            document.body.classList.remove('overflow-y-hidden');
          },
        };
      }),
      sortBy: { id: 'bankName', desc: false },
    };
    const onClose = () => {
      // financierNameModalDisplayRef.current = false;
      // showFinancierNameModal(financierNameModalDisplayRef.current)//false);
      showFinancierNameModal(false);
    };
    const onNoResultsFound = () => {
      return errors.financierNameList;
    };
    const onMessage = () => { };
    const paginationInput = {
      offset: 0,
      PAGE_SIZE: 4,
    };

    const data = [
      // {
      //   grid_data: [
      //     // {
      //     //   type: 'text',
      //     //   disabled: true,
      //     //   label: (
      //     //     <div>
      //     //       Business of the Insured
      //     //       <Text severity="error"> *</Text>
      //     //     </div>
      //     //   ),
      //     //   name: 'businessOfInsured',
      //     // },
      //   ],
      // },
      // {
      //   title: 'Previous Claims Experience',
      //   grid_data: [
      //     {
      //       type: 'radiogroup',
      //       label: (
      //         <>
      //           Was there any claims made in previous years?
      //           <Text severity="error"> *</Text>
      //         </>
      //       ),
      //       colSpan: repeat,
      //       className: '-mb-4',
      //       name: 'previousClaimExperienceDetails.isClaimMadeInPreviousYears',
      //       disabledGlobal: true,
      //       data: [
      //         {
      //           label: 'Yes',
      //           value: 'Yes',
      //         },
      //         {
      //           label: 'No',
      //           value: 'No',
      //         },
      //       ],
      //     },
      //     values?.previousClaimExperienceDetails?.isClaimMadeInPreviousYears
      //       ?.toString()
      //       ?.toLowerCase() === 'yes'
      //       ? {
      //           type: 'textarea',
      //           size: 'full',
      //           rows: 2,
      //           colSpan: repeat,
      //           disabled: true,
      //           label: (
      //             <>
      //               Tell us about the claims in previous years
      //               <Text severity="error"> *</Text>
      //             </>
      //           ),
      //           name: 'previousClaimExperienceDetails.claimInPreviousYearsInfo',
      //         }
      //       : null,
      //   ].filter((d) => d),
      // },

      {
        title: 'Policy Type',
        grid_data: [
          // {
          //   type: 'radiogroup',
          //   label: (
          //     <>
          //       Do you want this insurance for Kutcha Construction?
          //       <Text severity="error"> *</Text>
          //     </>
          //   ),
          //   colSpan: repeat,
          //   name: 'policyTypeDetails.isInsuranceForKutchaConstruction',
          //   disabledGlobal: true,
          //   data: [
          //     {
          //       label: 'Yes',
          //       value: 'Yes',
          //     },
          //     {
          //       label: 'No',
          //       value: 'No',
          //     },
          //   ],
          // },
          {
            type: 'select',
            size: 'full',
            disabled: true,
            label: (
              <>
                Policy/Cover Type<Text severity="error"> *</Text>
              </>
            ),
            name: 'policyTypeDetails.policyOrCoverType.code',
            data: [
              {
                label: policyTypeDetails?.policyOrCoverType?.code,
                value: policyTypeDetails?.policyOrCoverType?.value,
              },
            ],
          },
          {
            type: 'select',
            size: 'full',
            disabled: true,
            label: (
              <>
                Tenure<Text severity="error"> *</Text>
              </>
            ),
            name: 'policyTypeDetails.tenure.code',
            data: [
              {
                label: policyTypeDetails.tenure.code,
                value: policyTypeDetails.tenure.value,
              },
            ],
          },
          {
            type: 'date',
            size: 'full',
            disabled: false,
            label: (
              <>
                Policy Start Date<Text severity="error"> *</Text>
              </>
            ),
            name: 'riskDetails.policyStartDate',
          },
          {
            type: 'select',
            size: 'full',
            // disabled: true,
            label: (
              <>
                Height of the Building<Text severity="error"> *</Text>
              </>
            ),
            name: 'riskDetails.height_of_the_Building',
            data: [
              {
                label: 'Basement or Ground Floor',
                value: 'Basement or Ground Floor'
              },
              {
                label: '1st to 3rd Floor',
                value: '1st to 3rd Floor'
              },
              {
                label: 'Above 3rd Floor',
                value: 'Above 3rd Floor'
              },
            ],
          },
          {
            type: 'select',
            size: 'full',
            //disabled: true,
            label: (
              <>
                Type of Construction<Text severity="error"> *</Text>
              </>
            ),
            name: 'riskDetails.typeOfConstruction',
            data: [
              {
                label: 'Kutcha',
                value: 'Kutcha'
              },
              {
                label: 'Pucca',
                value: 'Pucca'
              },
              {
                label: 'Open',
                value: 'Open'
              },
            ],
          },
          {
            type: 'text',
            // label: <>Loan Account Number </>,
            label: (
              <div>
                Deductible
                <Text severity="error">*</Text>
              </div>
            ),
            name: 'riskDetails.deductible',
            disabled: true
          },
          {
            type: 'select',
            label: (
              <div>
                Construction Details
              </div>
            ),
            disabled: values?.riskDetails?.typeOfConstruction?.toString() !== 'Pucca',
            name: 'riskDetails.construction_Details',
            data: [
              {
                label: 'Concrete Frame Construction',
                value: 'Concrete Frame Construction'
              },
              {
                label: 'Green Building',
                value: 'Green Building'
              },
              {
                label: 'Large Panel Concrete Construction',
                value: 'Large Panel Concrete Construction'
              },
              {
                label: 'Light Gauge Steel Structures',
                value: 'Light Gauge Steel Structures'
              },
              {
                label: 'Load Bearing Masonry Wall Construction',
                value: 'Load Bearing Masonry Wall Construction'
              },
              {
                label: 'Pre Engineered Building Construction',
                value: 'Pre Engineered Building Construction'
              },
              {
                label: 'Precast Concrete Construction',
                value: 'Precast Concrete Construction'
              },
              {
                label: 'Puf Installation',
                value: 'Puf Installation'
              },
              {
                label: 'Steel Frame Structures',
                value: 'Steel Frame Structures'
              },
              {
                label: 'Tensile Structures',
                value: 'Tensile Structures'
              },
              {
                label: 'Wood Framed Construction',
                value: 'Wood Framed Construction'
              },
            ],
          },
          {
            type: 'select',
            label: (
              <div>
                Fire Protection Type<Text severity="error"> *</Text>
              </div>
            ),
            name: 'riskDetails.Fire_Protection_Type',
            data: [
              {
                label: 'Dry Chemical Fire Suppression Systems',
                value: 'Dry Chemical Fire Suppression Systems'
              },
              {
                label: 'Dry Pipe Systems',
                value: 'Dry Pipe Systems'
              },
              {
                label: 'Fire alarm systems',
                value: 'Fire alarm systems'
              },
              {
                label: 'Fixed Water Spray System',
                value: 'Fixed Water Spray System'
              },
              {
                label: 'Foam systems',
                value: 'Foam systems'
              },
              {
                label: 'Gas flooding systems',
                value: 'Gas flooding systems'
              },
              {
                label: 'Small bore hose reels',
                value: 'Small bore hose reels'
              },
              {
                label: 'Hydrant System',
                value: 'Hydrant System'
              },
              {
                label: 'Portable Extinguishers',
                value: 'Portable Extinguishers'
              },
              {
                label: 'Special Hazard Fire Protection Systems',
                value: 'Special Hazard Fire Protection Systems'
              },
              {
                label: 'Spot Protection',
                value: 'Spot Protection'
              },
              {
                label: 'Sprinkler System',
                value: 'Sprinkler System'
              },
              {
                label: 'Trailer Pumps/Fire Engines',
                value: 'Trailer Pumps/Fire Engines'
              },
              {
                label: 'Wet Fire Sprinkler Systems',
                value: 'Wet Fire Sprinkler Systems'
              },
            ],
          },
          {
            type: 'select',
            size: 'full',
            //  disabled: true,
            label: (
              <>
                PreAcceptance Inspection Done<Text severity="error"> *</Text>
              </>
            ),
            name: 'riskDetails.PreAcceptance_Inspection',
            data: [
              {
                label: 'Yes',
                value: 'Yes',
              },
              {
                label: 'No',
                value: 'No',
              },
            ],
          },
          {
            type: 'date',
            size: 'full',
            disabled: values?.riskDetails?.PreAcceptance_Inspection?.toString() !== 'Yes',
            label: (
              <>
                PreAcceptance Inspection Date
              </>
            ),
            name: 'riskDetails.PreAcceptance_Inspection_Date',
          },
          {
            type: 'select',
            size: 'full',
            //  disabled: true,
            label: (
              <>
                Voluntary Deductible
              </>
            ),
            name: 'riskDetails.Voluntary_Deductible',
            data: [
              {
                label: 'Yes',
                value: 'Yes',
              },
              {
                label: 'No',
                value: 'No',
              },
            ],
          },
          {
            type: 'number',
            disabled: values?.riskDetails?.Voluntary_Deductible?.toString() !== 'Yes',
            label: (
              <div>
                Voluntary Deductible %
              </div>
            ),
            name: 'riskDetails.Voluntary_Deductible_PCT',
            onKeyDown: (evt) => {
              if (
                evt.key === 'e' ||
                evt.key === '-' ||
                (evt.target.value.toString().includes('.') &&
                  evt.target.value
                    .toString()
                    .substring(
                      evt.target.value.toString().indexOf('.') + 1,
                    ).length === 5 &&
                  evt.key.toString().toLowerCase() !== 'backspace' &&
                  evt.key.toString().toLowerCase() !== 'arrowleft' &&
                  evt.key.toString().toLowerCase() !== 'arrowright')
              ) {
                evt.preventDefault();
              }
            },
          },
          {
            type: 'number',
            disabled: values?.riskDetails?.Voluntary_Deductible?.toString() !== 'Yes',
            label: (
              <div>
                Voluntary Deductible_Amount
              </div>
            ),
            name: 'riskDetails.Voluntary_Deductible_Amount',
            onKeyDown: (evt) => {
              if (
                evt.key === 'e' ||
                evt.key === '-' ||
                (evt.target.value.toString().includes('.') &&
                  evt.target.value
                    .toString()
                    .substring(
                      evt.target.value.toString().indexOf('.') + 1,
                    ).length === 5 &&
                  evt.key.toString().toLowerCase() !== 'backspace' &&
                  evt.key.toString().toLowerCase() !== 'arrowleft' &&
                  evt.key.toString().toLowerCase() !== 'arrowright')
              ) {
                evt.preventDefault();
              }
            },
          },
        ].filter((d) => d),
      },
      {
        title: 'Financier Details',
        grid_data: [
          {
            type: 'radiogroup',
            label: <>Do you want to add financer details?</>,
            colSpan: repeat,
            name: 'getFinancerDetails',
            disabledGlobal:
              buyFirePolicy?.proposalNumber !== '' ? true : false,
            data: [
              {
                label: 'Yes',
                value: 'Yes',
              },
              {
                label: 'No',
                value: 'No',
              },
            ],
          },
          values?.getFinancerDetails === 'Yes'
            ? {
              type: 'input-lookup',
              size: 'full',
              //disableSelect: true,
              label: (
                <div>
                  Financer Name<Text severity="error">*</Text>
                </div>
              ),
              name: 'financerName',
              loading: loadingFinancierName,
              onLookup: async (val, setFieldValue) => {
                if (val.toString().length > 0) {

                  setOnUpdate((_) => {
                    const newFunc = (data) => {
                      setFieldValue(
                        `financerName`,
                        // reformData(data.value, ''),
                        reformData(data.bankName, ''),
                      );
                      setFieldValue(`financerAddress`, '',);


                      setFieldValue(`financerAgreementType`, getDomainData && getDomainData.length > 0
                        ? getDomainData[1]?.code
                        : '',)

                      setFieldValue(`loanAccountNumber`, '');
                      setFieldValue(`fileNumber`, '');
                    };
                    return newFunc;
                  });
                  setSearchStringFinancierName(val);
                  try {
                    let queryOutput = fetchQuery({
                      fetchPolicy: 'network-only',
                      query: FINANCER_DROPDOWN_DETAILS_FIRE
                      ,
                      variables: {
                        input: {
                          bankName: val
                        },
                      }
                    });
                    setFinancierNameOutput([]);
                    showFinancierNameModal(true);
                    // financierNameModalDisplayRef.current = true;
                    // showFinancierNameModal(financierNameModalDisplayRef.current);//true);
                    setLoadingFinancierName(true);
                    let { data } = await queryOutput;
                    setLoadingFinancierName(false);
                    setFinancierNameOutput(
                      data.FireFinancierSearch.financier,
                      // data.bankName,
                    );
                    // setFinancierNameOutput(data);
                  }
                  catch (error) {
                    setErrors({
                      ...errors,
                      financierNameList: error?.message,
                    });
                    setLoadingFinancierName(false);
                    setFinancierNameOutput([]);
                  }
                }
              },
              onKeyDown: (evt) => {
                if (
                  (evt?.target?.value?.toString()?.endsWith(' ') &&
                    evt?.key === ' ') ||
                  (evt?.target?.value?.toString()?.length === 0 &&
                    evt?.key === ' ')
                ) {
                  evt.preventDefault();
                }
              },
              // data: FinancerNameData
              //   ? [
              //     ...FinancerNameData?.getDomainData.map(
              //       (finname) => {
              //         return {
              //           label: finname.value ? finname.value : '',
              //           value: finname.code ? finname.code : '',
              //         };
              //       },
              //     ),
              //   ]
              //   : [],
            }
            : null,
          values?.getFinancerDetails === 'Yes'
            ? {
              type: 'text',
              size: 'full',
              colSpan: repeat > 1 ? 2 : repeat,
              maxLength: 100,
              label: (
                <div>
                  Financer Address<Text severity="error">*</Text>
                </div>
              ),
              name: 'financerAddress',
            }
            : null,
          values?.getFinancerDetails === 'Yes'
            ? {
              type: 'select',
              size: 'full',
              label: (
                <div>
                  Financer Agreement Type
                  <Text severity="error">*</Text>
                </div>
              ),
              name: 'financerAgreementType',
              data: getDomainData
                ? [
                  ...getDomainData.map((fintype) => {
                    return {
                      label: fintype.value ? fintype.value : '',
                      value: fintype.code ? fintype.code : '',
                    };
                  }),
                ]
                : [],
            }
            : null,
          values?.getFinancerDetails === 'Yes'
            ? {
              type: 'text',
              size: 'full',
              maxLength: 50,
              label: (
                <div>
                  Loan Account Number<Text severity="error">*</Text>
                </div>
              ),
              name: 'loanAccountNumber',
            }
            : null,
          values?.getFinancerDetails === 'Yes'
            ? {
              type: 'text',
              size: 'full',
              label: (
                <div>
                  File Number
                </div>
              ),
              name: 'fileNumber',
            }
            : null,
        ].filter((d) => d),
      },
      {
        title: 'Risk Details',
        grid_data: [
          {
            type: 'select',
            size: 'full',
            disabled: buyFirePolicy?.proposalNumber?.length > 0,
            // disabled: true,
            label: (
              <>
                Home Type
              </>
            ),
            name: 'riskDetails.hometype',
            data: [
              {
                label: 'Multi-Storey',
                value: 'Multi-Storey',
              },
              {
                label: 'Standalone House',
                value: 'Standalone House',
              },
            ],
            onDataChange: (val, setFieldValue) => {
              setFieldValue(
                `floornumber`,
                '',
              );
            }
          },

          {
            type: 'number',
            size: 'full',
            disabled: buyFirePolicy?.proposalNumber.length > 0,
            disabled: values.riskDetails.hometype.toString() === 'Multi-Storey'
              ? false : true,
            label: (
              <>
                If Multi-Storey,then Floor. Of the House
              </>
            ),
            name: 'riskDetails.floornumber',
            onKeyDown: (evt) =>
              (evt.key === 'e' ||
                evt.key === '-' ||
                evt.key === '.') &&
              evt.preventDefault(),
          },

          {
            type: 'select',
            size: 'full',
            disabled: buyFirePolicy?.proposalNumber.length > 0,
            // disabled: true,
            label: (
              <>
                Is the Location having Basement
              </>
            ),
            name: 'riskDetails.basement',
            data: [
              {
                label: 'Yes',
                value: 'Yes',
              },
              {
                label: 'No',
                value: 'No',
              },
            ],
          },
          {
            type: 'number',
            size: 'full',
            disabled: buyFirePolicy?.proposalNumber.length > 0,
            // disabled: true,
            label: (
              <>
                Contents Sum Insured in Basement
              </>
            ),
            name: 'riskDetails.basementsi',

          },
          {
            type: 'select',
            size: 'full',
            disabled: buyFirePolicy?.proposalNumber.length > 0,
            // disabled: true,
            label: (
              <>
                Age of the Building
              </>
            ),
            name: 'riskDetails.buildingage',
            data: [
              {
                label: 'Less than 5 years',
                value: 'Less than 5 years',
              },
              {
                label: '5 to 10 years',
                value: '5 to 10 years',
              },
              {
                label: '10 to 20 years',
                value: '10 to 20 years',
              },
              {
                label: 'Above 20 years',
                value: 'Above 20 years',
              },
            ],
          },
          {
            type: 'select',
            size: 'full',
            // disabled: true,
            disabled: buyFirePolicy?.proposalNumber.length > 0,
            label: (
              <>
                Walls
              </>
            ),
            name: 'riskDetails.walls',
            data: [
              {
                label: 'Kutcha',
                value: 'Kutcha',
              },
              {
                label: 'Pucca',
                value: 'Pucca',
              },
            ],
          },
          {
            type: 'select',
            size: 'full',
            // disabled: true,
            disabled: buyFirePolicy?.proposalNumber.length > 0,
            label: (
              <>
                Floor
              </>
            ),
            name: 'riskDetails.floor',
            data: [
              {
                label: 'Kutcha',
                value: 'Kutcha',
              },
              {
                label: 'Pucca',
                value: 'Pucca',
              },
            ],
          },
          {
            type: 'select',
            size: 'full',
            // disabled: true,
            disabled: buyFirePolicy?.proposalNumber.length > 0,
            label: (
              <>
                Roof
              </>
            ),
            name: 'riskDetails.roof',
            data: [
              {
                label: 'Kutcha',
                value: 'Kutcha',
              },
              {
                label: 'Pucca',
                value: 'Pucca',
              },
            ],
          },
          {
            type: 'radiogroup',
            label: <>Do you want to change Risk Description ?</>,
            colSpan: repeat,
            name: 'riskDetails.updaterisk',
            disabledGlobal:
              buyFirePolicy?.proposalNumber !== '' ? true : false,
            data: [
              {
                label: 'Yes',
                value: 'Yes',
              },
              {
                label: 'No',
                value: 'No',
              },
            ],
          },

          {
            type: 'text',
            size: 'full',
            maxLength: "200",
            colSpan: repeat,
            name: `riskDetails.updateriskaddress`,

            disabled: values?.riskDetails?.updaterisk !== 'Yes'
            ,
            label: (
              <Text type={'label'}>
                Address <Text severity={'error'}>*</Text>
              </Text>
            ),

          },

        ].filter((d) => d),
      },
      // buyMotorPolicy?.coverData?.addOnCovers?.[b]?.selected === 
      nomineeDisplay ?
        {
          title: 'Nominee Details',
          grid_data: [
            ...memberList
              .map((mem, idx) => [
                {
                  type: 'select',
                  //size: 'full',
                  label: (
                    <div>
                      Insured Type
                      <Text severity="error">*</Text>
                    </div>
                  ),
                  name: `members[${idx}].relationship`,
                  data: applicableMemberTypes
                    ? [
                      ...applicableMemberTypes.map((fintype) => {
                        return {
                          label: fintype.label ? fintype.label : '',
                          value: fintype.label ? fintype.label : '',
                        };
                      }),
                    ]
                    : [],
                },
                {
                  type: 'text',
                  label: (
                    <Text type="label">
                      Name{' '}
                      {values?.members[idx]?.selected ? (
                        <Text severity="error">*</Text>
                      ) : null}
                    </Text>
                  ),
                  name: `members[${idx}].name`,
                  // disabled:
                  //   !values?.members[idx]?.selected ||
                  //   values?.quotationNo !== '',
                },
                {
                  type: 'number',
                  label: (
                    <Text type="label">
                      Sum Insured{' '}
                      {values?.members[idx]?.selected ? (
                        <Text severity="error">*</Text>
                      ) : null}
                    </Text>
                  ),
                  name: `members[${idx}].sumInsured`,
                  // disabled:
                  //   !values?.members[idx]?.selected ||
                  //   values?.quotationNo !== '',
                  onKeyDown: (evt) => {
                    if (
                      evt.key === 'e' ||
                      evt.key === '-' ||
                      (evt.target.value.toString().includes('.') &&
                        evt.target.value
                          .toString()
                          .substring(
                            evt.target.value.toString().indexOf('.') + 1,
                          ).length === 5 &&
                        evt.key.toString().toLowerCase() !== 'backspace' &&
                        evt.key.toString().toLowerCase() !== 'arrowleft' &&
                        evt.key.toString().toLowerCase() !== 'arrowright')
                    ) {
                      evt.preventDefault();
                    }
                  },
                },
                {
                  type: 'select',
                  label: (
                    <Text type="label">
                      Gender{' '}
                      {values?.members[idx]?.selected ? (
                        <Text severity="error">*</Text>
                      ) : null}
                    </Text>
                  ),
                  name: `members[${idx}].gender`,
                  // disabled:
                  //   !values?.members[idx]?.selected ||
                  //   !mem.selectGender ||
                  //   values?.quotationNo !== '',
                  // onDataChange: (val, setFieldValue) => {
                  //   if (mem.label === 'Self') {
                  //     setFieldValue(
                  //       'members[1].gender',
                  //       val === 'MALE'
                  //         ? 'FEMALE'
                  //         : 'FEMALE'
                  //           ? 'MALE'
                  //           : val,
                  //     );
                  //   }
                  // },
                  data: genderList.map((gender) => {
                    return {
                      label: gender?.value
                        ? gender?.value?.toString()
                        : '',
                      value: gender?.code
                        ? gender?.code?.toString()
                        : '',
                    };
                  }),
                },
                {
                  type: 'date',
                  label: (
                    <Text type="label">
                      Date of Birth{' '}
                      {values?.members[idx]?.selected ? (
                        <Text severity="error">*</Text>
                      ) : null}
                    </Text>
                  ),
                  name: `members[${idx}].dob`,
                  // disabled:
                  //   !values?.members[idx]?.selected ||
                  //   values?.quotationNo !== '',
                  onDataChange: (val, setFieldValue) =>
                    setFieldValue(
                      `members[${idx}].age`,
                      moment().diff(
                        moment(val, 'DD/MM/YYYY'),
                        'years',
                      ),
                    ),
                },
                {
                  type: 'text',
                  label: (
                    <Text type="label">
                      Name of Nominee{' '}
                      {values?.members[idx]?.selected ? (
                        <Text severity="error">*</Text>
                      ) : null}
                    </Text>
                  ),
                  name: `members[${idx}].nomineeName`,
                  // disabled:
                  //   !values?.members[idx]?.selected ||
                  //   values?.quotationNo !== '',
                },
                {
                  type: 'number',
                  label: (
                    <Text type="label">
                      Nominee Age{' '}
                      {values?.members[idx]?.selected ? (
                        <Text severity="error">*</Text>
                      ) : null}
                    </Text>
                  ),
                  name: `members[${idx}].nomineeAge`,
                  // disabled:
                  //   !values?.members[idx]?.selected ||
                  //   values?.quotationNo !== '',
                  onKeyDown: (evt) => {
                    if (
                      evt.key === 'e' ||
                      evt.key === '-' ||
                      (evt.target.value.toString().includes('.') &&
                        evt.target.value
                          .toString()
                          .substring(
                            evt.target.value.toString().indexOf('.') + 1,
                          ).length === 5 &&
                        evt.key.toString().toLowerCase() !== 'backspace' &&
                        evt.key.toString().toLowerCase() !== 'arrowleft' &&
                        evt.key.toString().toLowerCase() !== 'arrowright')
                    ) {
                      evt.preventDefault();
                    }
                  },
                },
                {
                  type: 'select',
                  //size: 'full',
                  label: (
                    <div>
                      Nominee Relationship
                      <Text severity="error">*</Text>
                    </div>
                  ),
                  name: `members[${idx}].nomineeRelationship`,
                  data: applicableNomineeTypes
                    ? [
                      ...applicableNomineeTypes.map((fintype) => {
                        return {
                          label: fintype.label ? fintype.label : '',
                          value: fintype.label ? fintype.label : '',
                        };
                      }),
                    ]
                    : [],
                },
                {
                  type: 'render',
                  component: (values) => {
                    let value = values?.members[idx]?.age ? values?.members[idx]?.dob : '0';
                    return (
                      <>
                        <Label
                          className="mb-2"
                          text="Age"
                        ></Label>
                        <div className="flex flex-row gap-2 items-center h-10">
                          {(
                            <Text className="w-20 text-base">
                              {moment().diff(
                                moment(value, 'DD/MM/YYYY'),
                                'years',
                              )}{' '}
                              Years
                            </Text>
                          )}
                          {idx ? (
                            <Text>
                              <FontAwesomeIcon
                                icon={faTrashAlt}
                                // className={`cursor-pointer ${
                                //   values?.quotationNo !== ''
                                //     ? 'text-neutral'
                                //     : 'text-secondary'
                                // }`}
                                size={'lg'}
                                onClick={(_) => {
                                  if (
                                    true
                                    //values?.quotationNo === ''
                                  ) {
                                    setFieldValue('members', [
                                      ...values?.members?.slice(
                                        0,
                                        idx,
                                      ),
                                      ...values?.members?.slice(
                                        idx + 1,
                                      ),
                                    ]);
                                    setMemberList([
                                      ...memberList?.slice(
                                        0,
                                        idx,
                                      ),
                                      ...memberList?.slice(
                                        idx + 1,
                                      ),
                                    ]);
                                  }
                                }}
                              />
                            </Text>
                          ) : ''}
                        </div><div class="divider py-1 bg-success"></div>
                      </>
                    );
                  },
                },
              ])
              .reduce((b, a) => [...b, ...a])
              .map((itm) => {
                return { ...itm };
              }),
            !values?.quotationNo
              // &&
              // applicableMemberTypes?.filter((applicable) =>
              //   isAllowed(applicable),
              // )?.length > 0
              ? {
                type: 'render',
                colSpan: 1,
                component: () => (
                  <div className="mb-2">
                    <Button
                      flat={false}
                      type={'button'}
                      className="w-full pl-4 max-h-10"
                      iconPre={
                        <FontAwesomeIcon icon={faPlus} />
                      }
                      onClick={(_) => {
                        updateBuyFirePolicyVar({
                          members: ([
                            ...values?.members,
                            {
                              relationship: '',
                              gender: null,
                              selectGender: true,
                              sumInsured: "",
                              maxAllowed: 1,
                              selected: false,
                              nomineeAge: "",
                              nomineeName: "",
                              nomineeRelationship: "",
                              age: "",
                              name: ""
                            }
                          ])
                        })
                        setMemberList([
                          ...values?.members,
                          {
                            relationship: '',
                            gender: null,
                            selectGender: true,
                            sumInsured: "",
                            maxAllowed: 1,
                            selected: false,
                            nomineeAge: "",
                            nomineeName: "",
                            nomineeRelationship: "",
                            age: "",
                            name: ""
                          }
                        ])
                        //setShowModalAddOthers(true)
                      }}
                    >
                      Add Others
                    </Button>
                  </div>
                ),
              }
              : null,
          ].filter((d) => d)
        } : '',
    ].filter((d) => d);

    const other_props = {
      flow: 'cols',
      repeat,
      gapX: 6,
      gapY: 0,
      spaceY: 2,
      size: 'full',
      titleSeverity: 'info',
    };

    return (
      <div className="mt-4">
        <Paper>
          <QuantaForm className="space-y-4 mt-3">
            <MixedGridGroup {...{ data, ...other_props }} />
          </QuantaForm>
          <QuantaForm>
            {/* <ModalAddOthers
            {...{
              setShowModalAddOthers,
              showModalAddOthers,
              applicableMemberTypes,
              genderList,
              memberList,
              setMemberList,
              values,
              setFieldValue,
              productCode,
              productName,
              lobCode,
              quoteNumber:1,
              updateBuyFirePolicyVar,
            }}
          /> */}
          </QuantaForm>
          <div>
            <SearchResultsModal
              {...{
                modalSizeExternal,
                modalDisplay: financierNameModalDisplay,  //financierNameModalDisplayRef.current,
                isFormWrapFlag: true,
                searchInput,
                searchResults,
                paginationInput,
                title: 'Search Financer Name',
                onClose,
                onDataUpdate,
                onNoResultsFound,
                onMessage,
                selectOnRowClick: true,
                firstRowClickRequired: false,
              }}
            />
          </div>
        </Paper>
      </div>
    );
  };

  const onSubmit = async (values) => {
    let ratePerMillie = 0;
    let addOnCoversRate = 0;
    let stfiCoverRate = 0;
    let earthquakeRate = 0;
    let rsmdCoverRate = 0;
    let terrorismCoverRate = 0;
    let lossMinAndTenantsRate = 0;
    try {
      if (Object.values(validate(values)).length === 0) {
        setParentAlerts([]);
        setProceedToNextStep([
          proceedToNextStep[0],
          true,
          ...proceedToNextStep.slice(2),
        ]);
        const coverFetchQuery = fetchQuery({
          query: COVER_FIRESA,
          variables: {
            input: {
              productCode: '1132',
              intermediaryCode: buyFirePolicy?.intermediary?.code
                ? buyFirePolicy?.intermediary?.code
                : quoteData?.intermediaryDetails?.code
                  ? quoteData?.intermediaryDetails?.code
                  // : dataintermediary?.selectedIntermediary?.intermediaryCode
                  //   ? dataintermediary?.selectedIntermediary?.intermediaryCode
                  : "",
              subProductName:
                buyFirePolicy?.quoteData?.productKg ?
                  buyFirePolicy?.quoteData?.productKg
                  : buyFirePolicy?.quoteData?.productName
                    ? buyFirePolicy?.quoteData?.productKg ?
                      buyFirePolicy?.quoteData?.productKg
                      : buyFirePolicy?.quoteData?.productName
                    : buyFirePolicy?.quoteData?.customerDetails?.productKg,
              riskType: quoteData?.customerDetails?.customerType?.value,//'Dwelling', 
              coverType: quoteData?.tabDetails?.customerTabDetails?.policyTypeDetails?.policyOrCoverType?.value, //'Home Contents' 
              eqZone: quoteData?.eqZone,
              typeOfCover: quoteData?.tabDetails?.customerTabDetails?.policyTypeDetails?.policyOrCoverType?.value, //policyTypeDetails.policyOrCoverType.value
              basisOfValuation: quoteData?.basisOfValuation
            }
          }
        });
        const { data: coverData } = await coverFetchQuery;
        const { coverListForSA } = coverData;
        coverListForSA?.riskCovers?.forEach((riksov) =>
          riksov?.covers?.forEach((cov) => {
            if (cov?.name?.toString() === 'Basic Fire Cover') {
              ratePerMillie = cov?.basicRate
            }
            if (cov?.name?.toString() === 'STFI') {
              stfiCoverRate = cov?.stfiRate
            }
            if (cov?.name?.toString() === 'Earthquake Fire and Shock') {
              earthquakeRate = cov?.eqRate
            }
            if (cov?.name?.toString() === 'Riot, Strikes, Malicious Damages') {
              rsmdCoverRate = cov?.rsmdRate
            }
            if (cov?.name?.toString() === 'Terrorism Damage Cover') {
              terrorismCoverRate = cov?.terrorismCover
            }
            if (cov?.name?.toString() === 'Loss Minimization Expenses' || 'Tenants Liability') {
              lossMinAndTenantsRate = parseFloat(cov?.stfiRate) +
                parseFloat(cov?.eqRate) +
                parseFloat(cov?.rsmdRate) +
                parseFloat(cov?.basicRate) * 0.1
            }
            if (cov?.name?.toString() !== ('Basic Fire Cover' || 'STFI' || 'Earthquake Fire and Shock' ||
              'Riot, Strikes, Malicious Damages' || 'Terrorism Damage Cover' || 'Loss Minimization Expenses' || 'Tenants Liability')
            ) {
              addOnCoversRate =
                parseFloat(cov?.stfiRate) +
                parseFloat(cov?.eqRate) +
                parseFloat(cov?.rsmdRate) +
                parseFloat(cov?.basicRate)
            }
            // addOnCovers = cov?.basicRate + 
          }
          )
        )
        updateBuyFirePolicyVar({
          ratePerMillie: ratePerMillie,
          addOnCoversRate: addOnCoversRate,
          stfiCoverRate: stfiCoverRate,
          earthquakeRate: earthquakeRate,
          rsmdCoverRate: rsmdCoverRate,
          terrorismCoverRate: terrorismCoverRate,
          lossMinAndTenantsRate: lossMinAndTenantsRate,
          policyTypeValue: policyTypeDetails?.policyOrCoverType?.value,
          financierDetails: {
            getFinancerDetails: values?.getFinancerDetails,
            financerName:
              values?.getFinancerDetails === 'Yes'
                ? values?.financerName
                : '',
            financerAddress:
              values?.getFinancerDetails === 'Yes'
                ? values?.financerAddress
                : '',
            financerAgreementType:
              values?.getFinancerDetails === 'Yes'
                ? values?.financerAgreementType
                : '',
            loanAccountNumber:
              values?.getFinancerDetails === 'Yes'
                ? values?.loanAccountNumber
                : '',
            fileNumber:
              values?.getFinancerDetails === 'Yes'
                ? values?.fileNumber
                : '',
          },
          riskDetails: {
            policyStartDate: values?.riskDetails?.policyStartDate
              ? values?.riskDetails?.policyStartDate
              : policyTypeDetails?.policyStartDate,
            hometype: values?.riskDetails?.hometype
              ? values?.riskDetails?.hometype
              : '',
            floornumber: values?.riskDetails?.floornumber
              ? values?.riskDetails?.floornumber
              : '',
            basement: values?.riskDetails?.basement
              ? values?.riskDetails?.basement
              : '',
            basementsi: values?.riskDetails?.basementsi
              ? values?.riskDetails?.basementsi
              : '',
            buildingage: values?.riskDetails?.buildingage
              ? values?.riskDetails?.buildingage
              : '',
            walls: values?.riskDetails?.walls
              ? values?.riskDetails?.walls
              : '',
            floor: values?.riskDetails?.floor
              ? values?.riskDetails?.floor
              : '',
            roof: values?.riskDetails?.roof
              ? values?.riskDetails?.roof
              : '',
            updaterisk: values?.riskDetails?.updaterisk
              ? values?.riskDetails?.updaterisk
              : '',
            updateriskaddress: values?.riskDetails?.updateriskaddress
              ? values?.riskDetails?.updateriskaddress
              : '',
            typeOfConstruction: values?.riskDetails?.typeOfConstruction
              ? values?.riskDetails?.typeOfConstruction
              : '',
            height_of_the_Building: values?.riskDetails?.height_of_the_Building
              ? values?.riskDetails?.height_of_the_Building
              : '',
            deductible: values?.riskDetails?.deductible
              ? values?.riskDetails?.deductible
              : '',
            construction_Details: values?.riskDetails?.construction_Details
              ? values?.riskDetails?.construction_Details
              : '',
            Fire_Protection_Type: values?.riskDetails?.Fire_Protection_Type
              ? values?.riskDetails?.Fire_Protection_Type
              : '',
            PreAcceptance_Inspection: values?.riskDetails?.PreAcceptance_Inspection
              ? values?.riskDetails?.PreAcceptance_Inspection
              : '',
            PreAcceptance_Inspection_Date: values?.riskDetails?.PreAcceptance_Inspection_Date
              ? values?.riskDetails?.PreAcceptance_Inspection_Date
              : '',
            Voluntary_Deductible: values?.riskDetails?.Voluntary_Deductible
              ? values?.riskDetails?.Voluntary_Deductible
              : '',
            Voluntary_Deductible_PCT: values?.riskDetails?.Voluntary_Deductible_PCT
              ? values?.riskDetails?.Voluntary_Deductible_PCT
              : '',
            Voluntary_Deductible_Amount: values?.riskDetails?.Voluntary_Deductible_Amount
              ? values?.riskDetails?.Voluntary_Deductible_Amount
              : '',
          },
          members: values?.members,
        });
        return true;
      }
      return false;
    }
    catch (error) {
      if (error?.message?.toLowerCase()?.includes("no data found")) {
        error.message = `Intermediary is not mapped with any Business Limit Policy`
        setParentAlerts([
          {
            header: 'Unable to proceed',
            id: Date.now(),
            content: (
              <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
                <span>{error?.message}</span>
              </div>
            ),
            type: 'warning',
            timeout: null,
            disableClose: false,
          },
        ]);
      }
      return false
    }
  };

  return (
    <div>
      <Text className="font-bold text-lg text-primary">Customer</Text>
      <QuantaFormik
        innerRef={props.forwardedRef}
        enableReinitialize={true}
        {...{
          initialValues,
          validate,
          onSubmit,
          validator: () => ({}),
        }}
      >
        <InsuredMemberForm {...{ validate }} />
      </QuantaFormik>
    </div>
  );
}
